import { OriginEnum } from "../enums/OriginEnum";

export const integrationToDisplayName = [
  OriginEnum.VNDA,
  OriginEnum.BLINGV3,
  OriginEnum.INTELIPOST,
  OriginEnum.ABBIAMO,
  OriginEnum.BAGY
]
